import { AbstractControl, ValidationErrors } from '@angular/forms';

export function PasswordValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  const errors: any = {};

  if (value.length < 8) errors.minLength = true;
  if (!/[a-z]/.test(value)) errors.hasLowerCase = true;
  if (!/[A-Z]/.test(value)) errors.hasUpperCase = true;
  if (!/[0-9]/.test(value)) errors.hasNumeric = true;
  if (!/[!@#$%^&*(),.?":{}|<>+-]/.test(value)) errors.hasSpecialChars = true;
  if (/\s/.test(value)) errors.withoutSpace = true;

  return Object.keys(errors).length ? errors : null;
}
